import { LitElement } from 'lit';
import store from '../store';
import config from '../config';
// eslint-disable-next-line import/no-cycle
import TemplateResolver, { TemplateNames } from '../components/templates/templateResolver';

class LitElementExtended extends LitElement {
  static get version() {
    const { version } = config;
    return version;
  }

  static get build() {
    return {
      target: '__buildTarget__',
      date: '__buildDate__',
    };
  }

  replaceElements() {
    const { config: { occluri, stylecontext } } = store.getState();
    const occl = !!occluri;

    const target = this.shadowRoot || this;

    // tooltips
    const tooltipTemplate = TemplateResolver.getInstance(occl).resolve('tooltipTemplate');
    const allAbbr: NodeListOf<HTMLElement> = target.querySelectorAll('[title]');
    allAbbr.forEach((node) => {
      const div = document.createElement('div');
      div.innerHTML = tooltipTemplate(stylecontext, node);

      node.parentNode.replaceChild(div.firstChild, node);
    });

    const replaceElementsInTemplate = (
      templateName: TemplateNames,
      selector: string,
      template: (node: HTMLElement) => string,
    ) => {
      TemplateResolver.getInstance(occl).resolve(templateName);
      const allElements: NodeListOf<HTMLElement> = target.querySelectorAll(selector);
      allElements.forEach((node) => {
        const div = document.createElement('div');
        div.innerHTML = template(node);

        node.parentNode.replaceChild(div.firstChild, node);
      });
    };

    if (!occl) {
      // links
      const linkTemplate = TemplateResolver.getInstance(occl).resolve('linkTemplate');
      target.querySelectorAll('a').forEach((node) => {
        const div = document.createElement('div');
        div.innerHTML = linkTemplate(node);

        node.parentNode.replaceChild(div.firstChild, node);
      });

      // em title
      const emTemplate = TemplateResolver.getInstance(occl).resolve('emTemplate');
      replaceElementsInTemplate('emTemplate', 'em', emTemplate);

      // coms-paragraph
      const comsP1Template = TemplateResolver.getInstance(occl).resolve('comsP1Template');
      replaceElementsInTemplate('comsP1Template', 'div.coms-paragraph-1', comsP1Template);

      const comsP2Template = TemplateResolver.getInstance(occl).resolve('comsP2Template');
      replaceElementsInTemplate('comsP2Template', 'div.coms-paragraph-2', comsP2Template);

      const comsP3Template = TemplateResolver.getInstance(occl).resolve('comsP3Template');
      replaceElementsInTemplate('comsP3Template', 'div.coms-paragraph-3', comsP3Template);

      // coms-text
      const comsText1Template = TemplateResolver.getInstance(occl).resolve('comsText1Template');
      replaceElementsInTemplate('comsText1Template', 'span.coms-text-1', comsText1Template);

      const comsText2Template = TemplateResolver.getInstance(occl).resolve('comsText2Template');
      replaceElementsInTemplate('comsText2Template', 'span.coms-text-2', comsText2Template);

      const comsText3Template = TemplateResolver.getInstance(occl).resolve('comsText3Template');
      replaceElementsInTemplate('comsText3Template', 'span.coms-text-3', comsText3Template);
    }
  }
}

export default LitElementExtended;
